<ion-content class="content-col">
  <ion-toolbar
    style="
      z-index: 999;
      position: sticky;
      top: 0;
      padding: 0 8px;
      border-bottom: 1px solid var(--ion-border-color);
    "
  >
    <span
      class="tab-nav-link"
      *ngFor="let p of appPages; let i = index"
      routerDirection="root"
      [routerLink]="[p.url]"
      lines="none"
      detail="false"
      routerLinkActive="tab-nav-active"
      #rla="routerLinkActive"
    >
      <ion-icon
        slot="start"
        [name]="rla.isActive ? p.icon : p.icon + '-outline'"
      ></ion-icon>
      {{ p.title }}
    </span>
  </ion-toolbar>

  <ion-router-outlet
    id="channel-admin-content"
    [environmentInjector]="environmentInjector"
  ></ion-router-outlet>
</ion-content>

<div class="left-col">
  <ion-card>
    <ion-list *ngIf="!channel" lines="none">
      <ion-list-header>
        <ion-skeleton-text
          [animated]="true"
          style="width: 80px"
        ></ion-skeleton-text>
      </ion-list-header>
      <ion-item>
        <ion-skeleton-text
          [animated]="true"
          style="width: 40%"
        ></ion-skeleton-text>
        <ion-label>
          <h3>
            <ion-skeleton-text
              [animated]="true"
              style="width: 60%"
            ></ion-skeleton-text>
          </h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-skeleton-text
          [animated]="true"
          style="width: 30%"
        ></ion-skeleton-text>
        <ion-label>
          <h3>
            <ion-skeleton-text
              [animated]="true"
              style="width: 70%"
            ></ion-skeleton-text>
          </h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-skeleton-text
          [animated]="true"
          style="width: 20%"
        ></ion-skeleton-text>
        <ion-label>
          <h3>
            <ion-skeleton-text
              [animated]="true"
              style="width: 80%"
            ></ion-skeleton-text>
          </h3>
        </ion-label>
      </ion-item>
      <ion-item>
        <ion-skeleton-text
          [animated]="true"
          style="width: 25%"
        ></ion-skeleton-text>

        <ion-label>
          <h3>
            <ion-skeleton-text
              [animated]="true"
              style="width: 75%"
            ></ion-skeleton-text>
          </h3>
        </ion-label>
      </ion-item>
    </ion-list>
    <div *ngIf="channel">
      <div
        class="header"
        *ngIf="channel.slackTeams?.length >= 1 && channel.slackTeams[0]?.icon"
      >
        <img src="{{ channel.slackTeams[0]?.icon }}" class="header-blur" />
      </div>
      <img
        src="{{ channel.slackTeams[0]?.icon }}"
        class="header-image"
        *ngIf="channel.slackTeams?.length >= 1 && channel.slackTeams[0]?.icon"
      />
      <ion-card-title>
        <h1 style="margin: 0 8px">
          <ion-input
            *ngIf="channel.name !== null && channel.name !== undefined"
            #channelNameInput
            [(ngModel)]="channel.name"
            class="input-field big-title-input"
            placeholder="Channel name"
            autocapitalize="sentences"
            (ionBlur)="saveEditedName()"
            style="font-size: 1.3rem; border: none"
          >
          </ion-input>
          <ion-input
            *ngIf="channel.name === null || channel.name === undefined"
            value="{{ PRIVATE_CHANNEL_NAME }}"
            class="input-field big-title-input"
            style="font-size: 1.3rem; border: none"
            disabled
          >
          </ion-input>
        </h1>
      </ion-card-title>
      <div class="hidden-vertical">
        <ion-button
          color="light"
          shape="round"
          class="btn-small circle-button"
          style="margin-left: 12px"
          (click)="viewInbox()"
          ngxTippy
          data-tippy-content="View in inbox"
          [tippyProps]="{
            placement: 'bottom'
          }"
        >
          <ion-icon name="file-tray"></ion-icon>
        </ion-button>
        <ion-button
          *ngIf="channel.type === CHANNEL_TYPES.SLACK"
          color="light"
          shape="round"
          class="btn-small circle-button"
          (click)="composeSlackBroadcast()"
          ngxTippy
          data-tippy-content="Compose broadcast"
          [tippyProps]="{
            placement: 'bottom'
          }"
        >
          <ion-icon name="send"></ion-icon>
        </ion-button>
        <ion-button
          color="light"
          shape="round"
          class="btn-small circle-button"
          (click)="openSlackChannel()"
          *ngIf="getSlackChannel()"
          ngxTippy
          data-tippy-content="Open channel in Slack"
          [tippyProps]="{
            placement: 'bottom'
          }"
        >
          <ion-icon name="logo-slack"></ion-icon>
        </ion-button>
        <ion-button
          color="light"
          shape="round"
          class="btn-small circle-button"
          (click)="showOptions()"
          ngxTippy
          data-tippy-content="More options"
          [tippyProps]="{
            placement: 'bottom'
          }"
        >
          <ion-icon name="ellipsis-vertical"></ion-icon>
        </ion-button>
      </div>
      <ion-list class="hidden-vertical" lines="none" style="padding-bottom: 0">
        <ion-item *ngIf="channel.type === CHANNEL_TYPES.EMAIL">
          <ion-label>
            <p>Email</p>
          </ion-label>
          <ion-label *ngIf="channel.inboundEmailRule.email" slot="end">
            <ion-icon name="mail"></ion-icon>
            {{ channel.inboundEmailRule.email }}
          </ion-label>
        </ion-item>
        <ion-item *ngIf="channel.type === CHANNEL_TYPES.SLACK">
          <ion-label>
            <p>Channel</p>
          </ion-label>
          <ion-label
            *ngIf="channel.slackChannel"
            (click)="openSlackChannel()"
            class="clickable"
            slot="end"
          >
            <ion-icon name="logo-slack"></ion-icon>
            {{ channel.slackChannel.name ?? PRIVATE_CHANNEL_NAME }}
          </ion-label>
          <ion-label *ngIf="!channel.slackChannel" slot="end">None</ion-label>
        </ion-item>

        <ion-item>
          <ion-label>
            <p>Created</p>
          </ion-label>
          <ion-label slot="end">
            {{ channel.createdAt | date: "MMM d yyyy" }}
          </ion-label>
        </ion-item>

        <ion-item>
          <ion-label>
            <p>Project</p>
          </ion-label>
          <ion-label (click)="selectProject()" class="clickable" slot="end">
            <ion-icon
              *ngIf="
                channel.project?.visibility === PROJECT_VISIBILITY.RESTRICTED
              "
              name="lock-closed"
            ></ion-icon>
            {{ channel.project?.name }}
          </ion-label>
        </ion-item>
      </ion-list>
      <ion-button
        size="block"
        color="dark"
        fill="clear"
        *ngIf="channel.type === CHANNEL_TYPES.EMAIL"
        (click)="editEmailConfiguration()"
        class="margin-10 button-dark-border"
      >
        <ion-icon name="mail" class="icon-padded"></ion-icon>
        Edit email configuration
      </ion-button>
      <ion-button
        size="block"
        color="dark"
        fill="clear"
        *ngIf="channel.type === CHANNEL_TYPES.WIDGET"
        (click)="editInAppChatConfiguration()"
        class="margin-10 button-dark-border"
      >
        <ion-icon name="chatbubble" class="icon-padded"></ion-icon>
        Edit chat configuration
      </ion-button>
      <ion-button
        size="block"
        color="dark"
        fill="clear"
        *ngIf="channel.type === CHANNEL_TYPES.MICROSOFT_TEAMS"
        (click)="editMicrosoftTeamsConfiguration()"
        class="margin-10 button-dark-border"
      >
        <ion-icon name="custom-teams" class="icon-padded"></ion-icon>
        Edit Microsoft Teams configuration
      </ion-button>
    </div>
  </ion-card>

  <ion-card
    class="hidden-vertical"
    *ngFor="let account of accounts"
    style="margin-top: 25px"
  >
    <ion-card-content class="flex-space-between">
      <ion-card-subtitle>
        <ion-icon name="business" class="padded-icon"></ion-icon>
        Account: {{ account.name }}
      </ion-card-subtitle>
      <div
        *ngIf="
          account?.externalCrmMetadata?.id &&
          authService.tenant?.externalCrmConfig?.enabled
        "
      >
        <a [href]="account?.externalCrmMetadata.url" target="_blank">
          Open in {{ this.authService.tenant.externalCrmConfig.name }}
          <ion-icon name="open"></ion-icon>
        </a>
      </div>
    </ion-card-content>
    <ion-list lines="none" class="no-padding">
      <ion-item style="align-items: center">
        <ion-label>
          <p>Domains</p>
        </ion-label>
        <ion-label>
          {{
            account.emailsAndDomains
              ? account.emailsAndDomains.join(", ")
              : "None"
          }}
        </ion-label>
      </ion-item>
    </ion-list>
    <app-response-input
      *ngIf="account.customFields?.length"
      [responseInputFields]="account.customFields"
      [showPublicOption]="false"
      layout="list"
      [isReadOnly]="true"
    >
    </app-response-input>
    <ion-button
      fill="clear"
      color="dark"
      class="btn-small"
      (click)="editAccount(account.id)"
    >
      Edit account
    </ion-button>
  </ion-card>

  <ion-card class="hidden-vertical" *ngIf="channel" style="margin-top: 25px">
    <ion-card-content>
      <ion-card-subtitle> Tags </ion-card-subtitle>
    </ion-card-content>
    <ion-button
      class="btn-small"
      shape="round"
      color="light"
      *ngFor="let tag of channel.tags"
      (click)="editTag(tag)"
    >
      <ion-icon
        name="pricetags"
        style="margin-right: 4px; font-size: 0.75rem"
      ></ion-icon>
      {{ tag.name }}
    </ion-button>
    <ion-button fill="clear" color="dark" class="btn-small" (click)="addTag()">
      <ion-icon name="add-outline" class="icon-padded"></ion-icon>
      Add tag
    </ion-button>
  </ion-card>
</div>
